import { has, compose, transform, get, entries, over, getOr } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getOrEmptyObject, getOrNull, getStringProp } from '@mews/fp';
import { createAsyncMetaSelectors, createScopedSelector } from '@mews/framework';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { moduleSelector } from '../module';

const parentSelector = createSelector(moduleSelector, (state) => state.basket);
const getBasket = createScopedSelector({ parentSelector, initialState: { ...META_STATE_SUCCEEDED } });

const getMeta = createSelector(getBasket, getOrEmptyObject('meta'));
const getPrices = createSelector(getBasket, getOrEmptyObject('prices'));
export const getProducts = createSelector(getBasket, getOrEmptyObject('products'));
export const getReservationKey = createSelector(getBasket, get('reservationKey'));

const getTotalPrice = get('totalCost');
export const getTotalPrices = createSelector(
    getPrices,
    compose(
        transform((acc, [key, value]) => {
            acc[key] = getTotalPrice(value);
            return acc;
        }, {}),
        entries
    )
);
export const [isBasketFetching, hasBasketFailed] = createAsyncMetaSelectors(getMeta);

export const hasReservationPrice = createSelector(getStringProp('reservationKey'), getPrices, has);

export const getReservationTotalPrice = compose(
    ([key, prices]) => getOrNull(key, prices),
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    over([getStringProp('reservationKey'), getTotalPrices])
);

export const getReservationProductCounts = createSelector(getStringProp('reservationKey'), getProducts, get);

const getReservationProductCount = createSelector(getStringProp('productId'), getReservationProductCounts, get);

export const getReservationProductUnitCount = compose(getOr(0, 'unitCount'), getReservationProductCount);

export const getReservationProductPersonCount = compose(getOr(0, 'personCount'), getReservationProductCount);

export const getReservationServiceId = compose(get('serviceId'), getBasket);
